import { Label, Sprite, _decorator } from 'cc';
import BaseMachineRecord from './BaseMachineRecord';
import NumberFormatter from '../../../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';
import TimeLabel from '../../../../../../common/scripts/Toolkit/Components/Misc/TimeLabel';
import RemoteLoader from '../../../../../../common/scripts/Toolkit/Helper/Loading/RemoteLoader';
import Lobby from '../../../../../System/Lobby';
import PreviewHistoryData from '../../../../Data/DataObject/History/PreviewHistoryData';

enum EventType {
    ENTER_MACHINE = 'ENTER_MACHINE',
}

const { ccclass, property } = _decorator;

@ccclass('MachineRecord')
export default class MachineRecord extends BaseMachineRecord {
    public static readonly EVENT_TYPE = { ...EventType, ...BaseMachineRecord.EVENT_TYPE };

    @property(Label)
    private readonly machineName: Label = null;

    @property(Label)
    private readonly machineID: Label = null;

    @property(NumberFormatter)
    private readonly profitOrLossNumber: NumberFormatter = null;

    @property(Label)
    private readonly betCount: Label = null;

    @property(NumberFormatter)
    private readonly totalBet: NumberFormatter = null;

    @property(Sprite)
    private readonly image: Sprite = null;

    @property(TimeLabel)
    private readonly timeLabel: TimeLabel = null;

    protected declare displayedData: PreviewHistoryData;

    public onLoad() {
        super.onLoad();
        // this.image.on(Node.EventType.TOUCH_END, () => {
        //     this.node.emit(EventType.ENTER_MACHINE, this.displayedData.tableID);
        // });
    }

    protected updateContent(data: PreviewHistoryData) {
        this.machineName.string = data.machineName;
        this.machineID.string = `(${data.machineID})`;
        this.profitOrLossNumber.value = data.win - data.bet;
        this.betCount.string = data.betCount.toString();
        this.totalBet.value = data.bet;
        this.timeLabel.time = data.timestamp;
        const imageURL = Lobby.hall.getGameDataByID(Lobby.hall.currentHallID, data.gameID, Lobby.history.currentRecordType)?.Asset.Logo;
        if (imageURL) {
            RemoteLoader.loadSpriteFrame(imageURL).then((spriteFrame) => {
                this.image.spriteFrame = spriteFrame;
            });
        } else {
            this.image.spriteFrame = null;
        }
    }
}
